import BaseParametersFormattingStrategy from "../../parametersFormatting/BaseParametersFormattingStrategy";
import ParametersFormatter from "../../parametersFormatting/ParametersFormatter"
import messageResource from "../../messageResource"
import ATReportParamsStringBuilder from '../reportParamsStringBuilder/ATReportParamsStringBuilder'
import DateRangeFormattingStrategy from '../../parametersFormatting/DateRangeFormattingStrategy'

const ParametersFormattingStrategy = function() {};

ParametersFormattingStrategy.prototype = _.create(BaseParametersFormattingStrategy.prototype, {

    init: function(
        selectorsData,
        dateFormat,
        productSettingsValidator,
        reportRightsValidator,
        reportAuthorizationInfo,
    ) {
        BaseParametersFormattingStrategy.prototype.init.call(this, {selectorsData, dateFormat, reportAuthorizationInfo});
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;
        this.formatUtil = OvertimeReportFormatUtils;

        return this;
    },

    createParametersFormatter: function({selectorsData, dateFormat, reportAuthorizationInfo}) {
        return new ParametersFormatter().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            reportAuthorizationInfo: reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
        })
    },

    createDateParametersFormattingStrategy: function(config) {
        return new DateRangeFormattingStrategy(config.dateFormat)
    },

    formatMainPartOfLightboxTitle: function(selectedParameters)
    {
        var reportName = this.formatUtil.makePDFTitle(selectedParameters);
        var showBy = this.formatUtil.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        return messageResource.getMessage("common_report.pdf.title", [reportName, showBy, dateParameters]);
    },

    formatParametersText: function(selectedParameters)
    {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection);
    }
});

export default ParametersFormattingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/ParametersFormattingStrategy.js